<template>
  <div class="product-list">
    <rotaion
      :height="height"
      :route="this.$route.path"
      arrow="never"
      position="none"
    ></rotaion>
    <div class="center-content">
      <div class="product-data">
        <div class="product-data-total">
          <div class="product-data-text">发行游戏数</div>
          <div class="product-data-num">300+</div>
        </div>
        <div
          class="product-data-total"
          style="border-left: 1px solid gray; border-right: 1px solid gray"
        >
          <div class="product-data-text">每日在线玩家</div>
          <div class="product-data-num">500万+</div>
        </div>
        <div class="product-data-total">
          <div class="product-data-text">累计注册用户</div>
          <div class="product-data-num">8亿+</div>
        </div>
      </div>

      <div class="game-list">
        <div v-for="(item, index) in games" :key="index" class="game-item">
          <el-tooltip effect="light" placement="top">
            <div slot="content" class="game-list-image-code">
              <el-image :src="item.code" fit="cover"></el-image>
              <span>体验一下</span>
            </div>

            <div
              :style="{ 'background-image': 'url(' + item.image + ') ' }"
              class="game-list-image"
            ></div>
          </el-tooltip>
          <div class="game-list-bottom">
            <el-image :src="item.avatar" fit="cover"></el-image>
            <div class="game-list-text">
              <span style="font-size: 20px; font-weight: 500; color: #000">{{
                item.name
              }}</span>
              <span>日活跃量:{{ item.dau }}</span>
            </div>
          </div>
        </div>
      </div>
      <bottom></bottom>
    </div>
  </div>
</template>
<script>
import rotaion from "./components/rotation";
import bottom from "./components/bottom";
export default {
  components: { rotaion, bottom },
  data() {
    return {
      height: window.innerHeight,
      games: [
        {
          name: "枪王射击",
          avatar:
            "https://game-cdn.feigo.fun/uploads/20191009/jEdUJryV8fObWuDxRWb4byUN2qs7hd3l.png",
          image:
            "https://game-cdn.feigo.fun/uploads/20201202/K7VN86Dr1OKvGjqCnXnkKqsviUHSnpqO.png",
          code: "https://game-cdn.feigo.fun/uploads/20201111/YirOD2yBfWyLVvaBpAhjStYoKAzpaPaH.png",
          dau: "128万+",
        },
        {
          name: "王者搭桥",
          avatar:
            "https://game-cdn.feigo.fun/uploads/20190624/GTPLzNawnFiR1Up5v4xgeQNv2eYELlkq.png",
          image:
            "https://game-cdn.feigo.fun/uploads/20201202/kn4p9CpXgtFb7k3ntj64ZyEPlNJlWJhp.png",
          code: "https://game-cdn.feigo.fun/uploads/20201202/fig3OxVlxcCCpDm64sRaL3IhHxAzNn5q.png",
          dau: "60万+",
        },
        {
          name: "超级坦克王",
          avatar:
            "https://game-cdn.feigo.fun/uploads/20190713/NaYm08276CIsDTMdOAM9Ppp6iR3hz8Dv.png",
          image:
            "https://game-cdn.feigo.fun/uploads/20201202/REi84uAgf7gnA84icHNE8mwcFKWyu0MP.png",
          code: "https://game-cdn.feigo.fun/uploads/20201111/pnnoz8tbHMBi8E64A9FKY2pnJIVHUmrj.png",
          dau: "36万+",
        },
        {
          name: "节奏弹球",
          avatar:
            "https://game-cdn.feigo.fun/uploads/20190817/6Qt7oaR3j7ARHanFdC5DIfD4QKyy8TvU.png",
          image:
            "https://game-cdn.feigo.fun/uploads/20201202/BaL94fNet9kwA1NKJU6ymVvCggYGHkMt.png",
          code: "https://game-cdn.feigo.fun/uploads/20201202/BUm2lJGkbrerdY6XBwyWXshELu6znCTP.png",
          dau: "32万+",
        },
        {
          name: "我是拳王",
          avatar:
            "https://game-cdn.feigo.fun/uploads/20201021/vX6hFYRyrnGl0fVgCNser11LpteLoK7Z.png",
          image:
            "https://game-cdn.feigo.fun/uploads/20201202/ApXmU9x6YCRNgfLxQXj9MusM3iBFvfmt.png",
          code: "https://game-cdn.feigo.fun/uploads/20201202/xgqelHmX0kxt0CcxjlrhYThj8dk6P3jy.png",
          dau: "23万+",
        },
        {
          name: "竞速车神",
          avatar:
            "https://game-cdn.feigo.fun/uploads/20191226/G1bEweAshzCz8tuKUui3GtGCPgPAyBdx.png",
          image:
            "https://game-cdn.feigo.fun/uploads/20201202/ahTLCIH5YC2ct1AL1tq5KftsFAA6e4De.png",
          code: "https://game-cdn.feigo.fun/uploads/20201202/i75kztBXSRAiX5GVSpWA49XtuAr67Siz.png",
          dau: "30万+",
        },
        {
          name: "沙漠球球",
          avatar:
            "https://game-cdn.feigo.fun/uploads/20191022/Vf6qcRWvvxcnUahwaZh71DkNFfTakg9H.png",
          image:
            "https://game-cdn.feigo.fun/uploads/20201202/VGaqxjAdA1Xui9QogqaTo5JBDrQly5t0.png",
          code: "https://game-cdn.feigo.fun/uploads/20201202/tonsJ6fIefEiEAVaodSjZAxriMJaIA8t.png",
          dau: "106万+",
        },
        // {
        //   name: "一枪神探",
        //   avatar:
        //     "https://game-cdn.feigo.fun/uploads/20201202/PL3WJlvvYSp5SIAXZ5VJSgXB1Jb60xqK.png",
        //   image:
        //     "https://game-cdn.feigo.fun/uploads/20201202/o0EPEGJAESjB8kBwhWCcW3NsdT9MbDoZ.png",
        //   code:
        //     "https://game-cdn.feigo.fun/uploads/20201202/MfrBoiAFACEbuzrp0dYsOes6mcn5YgZR.png",
        //   dau: "25万+",
        // },
        {
          name: "成语考功名",
          avatar:
            "https://game-cdn.feigo.fun/uploads/20211005/HkCXTgeTz1Fx487x14b07XqfFcXlajTT.png",
          image:
            "https://game-cdn.feigo.fun/uploads/20211005/HkCXTgeTz1Fx487x14b07XqfFcXlajTT.png",
          code: "https://game-cdn.feigo.fun/uploads/20211005/HkCXTgeTz1Fx487x14b07XqfFcXlajTT.png",
          dau: "30万+",
        },

        {
          name: "糖逗人冲鸭",
          avatar:
            "https://game-cdn.feigo.fun/uploads/20201021/bQn5IOso15g1VhM2b5gP3tW5yFqFlRF2.png",
          image:
            "https://game-cdn.feigo.fun/uploads/20201202/MB6rAeqJSs6aE78ipygXKrQP6y037FMW.png",
          code: "https://game-cdn.feigo.fun/uploads/20201202/Ssobwkjt0vTRC5s1qpo7bXrjhHHwb0M8.png",
          dau: "18万+",
        },
        {
          name: "小小神箭手",
          avatar:
            "https://game-cdn.feigo.fun/uploads/20200618/hOu0T4p5HBBXDov6LvHpK9Ofhyfzsrvm.png",
          image:
            "https://game-cdn.feigo.fun/uploads/20201202/P0oY4Quns3LyvrGRHHC3PvczovPEawK3.png",
          code: "https://game-cdn.feigo.fun/uploads/20201111/skljMzxFH77fncL9bwVxuNIRD5CZSgi8.png",
          dau: "25万+",
        },
        {
          name: "天梯跑酷",
          avatar:
            "https://game-cdn.feigo.fun/uploads/20200828/QO91QXtnH2b42cZEMbPWeEkMHOW9DtfK.png",
          image:
            "https://game-cdn.feigo.fun/uploads/20201202/rlovjluWTXctPpnXI5RNslUR0fyM4CTS.png",
          code: "https://game-cdn.feigo.fun/uploads/20201202/oAadfk4hmlV3gu5bdCasLa2NXYrNVp7a.png",
          dau: "28万+",
        },
        {
          name: "搬砖大佬",
          avatar:
            "https://game-cdn.feigo.fun/uploads/20200727/OTJ7wazYtzXMRUgSkIob8t2ElKBWAcTl.png",
          image:
            "https://game-cdn.feigo.fun/uploads/20201202/GjJxlMk5MClRnPFBXlU8eubR2QsaoTnk.png",
          code: "https://game-cdn.feigo.fun/uploads/20201202/bjAzmyW9gQyDDOPenQW3x83RYXRWPvmV.png",
          dau: "32万+",
        },
      ],
    };
  },
};
</script>
<style  src='./css/product-list.css'>
</style>